@if (filters.length) {
  <select (change)="activate($event)" class="mr-2" data-zid="position-filter">
    <option value="" disabled [selected]="isInitial">{{ 'position-filter.placeholder' | transloco }}</option>
    @for (filter of filters; track $index) {
      <option [selected]="filter.type === overrideCurrentFilter || (filter.isActive && !isInitial)" [value]="filter.type">
        {{ 'position-filter.' + filter.type | transloco }}
      </option>
    }
  </select>
}
